import { useContext, useEffect, useState } from "react";
import { RSODynamicInput } from "../../../../utils/RSODynamicInput/RSODynamicInput"
import { getNowDate } from "../../../../../../utils/utils";
import { dispatcher_context } from "../../hooks/useStats_dispatcher";
import { RSODynamicButtonGroup } from "../../../../utils/RSODynamicButtonGroup/RSODynamicButtonGroup"
import { RSODynamicDispDateReportHourly } from "./components/RSODynamicDispDateReportHourly";
import { RSODynamicDispDateReportWater } from "./components/RSODynamicDispDateReportWater";
import { RSODynamicDispDateReportGraphics } from "./components/RSODynamicDispDateReportGraphics";
import { RSODynamicDispDateReportGraphicsPeriod } from "./components/RSODynamicDispDateReportGraphicsPeriod";
import { getDispatcherPeriodReportGraphics } from "../../http/dispatcherHttp";
import AuthContext from "../../../../../../context/AuthContext";
import { RSODynamicSelect } from "../../../../utils/RSODynamicSelect/RSODynamicSelect";

export let RSODynamicDispDateReport = () => {

  let { dateReportTab,
    selectedDate,
    selectedPeriodWPS,
    selectedStartOfPeriodDate,
    selectedEndOfPeriodDate,
    setDateReportTab,
    setSelectedDate,
    setSelectedStartOfPeriodDate,
    setSelectedEndOfPeriodDate,
    setSelectedPeriodWPS, } = useContext(dispatcher_context);

  let { authTokens } = useContext(AuthContext);

  let [WPSListForPeriod, setWPSListForPeriod] = useState([])
  const isPeriodReport = dateReportTab === 'График за период';

  useEffect(() => {
    const fetchData = async () => {
      const data = await getDispatcherPeriodReportGraphics(authTokens, selectedStartOfPeriodDate, selectedEndOfPeriodDate, setWPSListForPeriod);
      setWPSListForPeriod(Object.keys(data));
      setSelectedPeriodWPS(Object.keys(data)[0])
    };

    fetchData();
  }, [authTokens, selectedStartOfPeriodDate, selectedEndOfPeriodDate]);

  return (
    <div className="large__container">
      <div className="container RSODynamicControls">
        <RSODynamicButtonGroup
          buttons={[
            { title: 'Почасовые показатели' },
            { title: 'Вода за месяц' },
            { title: 'График за дату' },
            { title: 'График за период' },
          ]}
          setter={setDateReportTab}
          getter={dateReportTab}
          color='green' />

        {!isPeriodReport ? (
          <form className="RSODynamicDateReport__filters">
            <RSODynamicInput
              type='date'
              title='Выберите дату'
              name='selectDate'
              setter={setSelectedDate}
              selectedDate={selectedDate}
              value={selectedDate}
              required={true}
            />
          </form>
        ) : (
          <div className="RSODynamicDateReport__filters">
            <div>
              <RSODynamicInput
                type='date'
                title='Выберите начало периода'
                name='selectDate'
                setter={setSelectedStartOfPeriodDate}
                required={true}
              />
            </div>
            <div>
              <RSODynamicInput
                type='date'
                title='Выберите конец периода'
                name='selectDate'
                setter={setSelectedEndOfPeriodDate}
                required={true}
              />
            </div>
            <div className="RSODynamicSelect">
              <label className="form-label">Выберите ВЗУ</label>
              <select className='form-input'
                onChange={e => setSelectedPeriodWPS(e.target.value)}
                value={selectedPeriodWPS}>
                {WPSListForPeriod?.map((item, index) =>
                  <option key={item} value={item}>{`${item}`}</option>
                )}
              </select>
            </div>
          </div>
        )}
      </div>

      {dateReportTab === "Почасовые показатели" &&
        <RSODynamicDispDateReportHourly />}

      {dateReportTab === "Вода за месяц" &&
        <RSODynamicDispDateReportWater />}

      {dateReportTab === "График за дату" &&
        <RSODynamicDispDateReportGraphics />}

      {dateReportTab === "График за период" &&
        <RSODynamicDispDateReportGraphicsPeriod />}
    </div>
  )
}
